// extracted by mini-css-extract-plugin
export default {"productGallery":"UF-z","inQuickShop":"VF-z"};